import React from 'react';
import { AccessPage } from './components/AccessPage';

export function MainView(): JSX.Element {
  return (
    <div className="checkaccess-react-portlet">
      <AccessPage />
    </div>
  );
}
